export default {
  target: "[data-aspect]",
  init() {
    this.process();
    window.addEventListener("resize", () => this.process());
  },
  process() {
    const elems = document.querySelectorAll(this.target);
    elems.forEach(item => this.calculate(item));
  },
  calculate(item) {
    const aspect = item.getAttribute("data-aspect").split(":");
    const aspects = item.getAttribute("data-aspect-responsive");
    let aspectW = parseInt(aspect[0]);
    let aspectH = parseInt(aspect[1]);
    if (aspects) {
      const responsiveData = JSON.parse(aspects);
      Object.keys(responsiveData).forEach(key => {
        const windowWidth = document.body.clientWidth;
        const responsiveAspect = responsiveData[key].split(':')
        if (key < windowWidth) {
          aspectW = parseInt(responsiveAspect[0])
          aspectH = parseInt(responsiveAspect[1])
        }
      });
    }
    const resAspect = aspectW / aspectH;
    const finalAspect = item.getBoundingClientRect().width / resAspect;
    item.style.height = `${finalAspect}px`;
  },

};